export default "__VITE_ASSET__0a9d8e4e__"